module.exports = __webpack_public_path__ + "img/avatar2.3e5b9c2f.png";